import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Flex,
  Body,
  Heading,
  BackgroundImage,
} from '@edreamsodigeo/prisma-design-system';
import { useImagePathWithBrand } from '@/hooks/useImagePath';
import { PrimeLogoPill } from '../PrimePills';
import { useIsPrimeUser } from '@/hooks/useIsPrimeUser';

const PrimeHeader = ({
  title,
  subtitle,
  subtitleProps = {},
  paddingFromLogo = 'huge',
}) => {
  const backgroundImage = useImagePathWithBrand(
    'price_freeze_pict{brand}2x.png'
  );
  const hasPrimeLogoPill = useIsPrimeUser();
  return (
    <Box
      borderBottomLeftRadius={2}
      borderBottomRightRadius={2}
      sx={{
        background: 'linear-gradient(180deg, #66B5FF -53.41%, #E6F3FF 102.34%)',
      }}
    >
      <BackgroundImage
        backgroundRepeat="no-repeat"
        backgroundPosition="bottom right"
        backgroundSize="contain, 100% 20%"
        backgroundImage={`url(${backgroundImage})`}
        width="100%"
      >
        <Box pl="base" pr="base" pt="big" pb="huge">
          <Flex pb="small">
            <Box pr="1x_small">
              {hasPrimeLogoPill && (
                <Box data-testid="prime-pill">
                  <PrimeLogoPill />
                </Box>
              )}
            </Box>
          </Flex>
          <Box>
            <Box pb="2x_small">
              <Heading type="2" weight="medium" color="primary.90">
                {title}
              </Heading>
            </Box>
            <Box pr={paddingFromLogo}>
              <Body
                type="base"
                weight="normal"
                color="primary.90"
                {...subtitleProps}
              >
                {subtitle}
              </Body>
            </Box>
          </Box>
        </Box>
      </BackgroundImage>
    </Box>
  );
};

PrimeHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  subtitleProps: PropTypes.object,
};

export default PrimeHeader;
